import { useState, useEffect } from "react";
import axios from "axios";
import { SERVERURL } from "../../ServerUrl";

// Fetch-once + client-side search, shared by every admin list screen.
// `searchField` is the record property the search box filters on.
const useAdminList = (endpoint, searchField = "title") => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    let active = true;

    const fetchItems = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(`${SERVERURL}/api/v1/${endpoint}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
        });

        if (active && Array.isArray(response.data)) {
          setItems(response.data);
        }
      } catch (error) {
        console.error(`Error fetching ${endpoint}:`, error);
      } finally {
        if (active) setLoading(false);
      }
    };

    fetchItems();
    return () => {
      active = false;
    };
  }, [endpoint]);

  const visibleItems = items.filter((item) =>
    (item?.[searchField] || "").toLowerCase().includes(searchValue.toLowerCase())
  );

  return { items: visibleItems, loading, searchValue, setSearchValue };
};

export default useAdminList;
